import { LineofBusinessFilterData } from "../models/LineofBusinessFilterData";

export const pageSize = 14;

export const lineofBusinessFilterData: LineofBusinessFilterData[] = [
  { label: "Electrical", value: "electrical" },
  { label: "Plumbing", value: "plumbing" },
];
